"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandUpdateSchema = exports.brandCreateSchema = exports.brandSchema = exports.brandDocumentSchema = void 0;
const zod_1 = require("zod");
const slug_field_1 = require("../slug-field");
// Marka belgesi (MinIO'da tutulan PDF katalog/broşür): lokalize başlık + URL.
exports.brandDocumentSchema = zod_1.z.object({
    title: zod_1.z.string().min(1, "Belge başlığı zorunludur"),
    titleEn: zod_1.z.string().nullable().optional(),
    // Yalnızca same-origin göreli yol (/…) veya http(s) — javascript:/data: şemalarını engelle.
    url: zod_1.z
        .string()
        .min(1, "Belge dosyası zorunludur")
        .refine((u) => /^\/(?!\/)/.test(u) || /^https?:\/\//i.test(u), "Geçersiz belge URL'i"),
});
// Full DB row schema — updated to match Prisma Brand model fields
exports.brandSchema = zod_1.z.object({
    id: zod_1.z.string().cuid().optional(),
    name: zod_1.z.string().min(1, "Marka adı zorunludur").max(191),
    nameEn: zod_1.z.string().max(191).nullable().optional(),
    initial: zod_1.z.string().min(1, "Başlangıç harfi zorunludur").max(191),
    categories: zod_1.z.string().min(1, "Kategoriler zorunludur"),
    categoriesEn: zod_1.z.string().nullable().optional(),
    logoUrl: zod_1.z.string().max(500).default(""),
    featured: zod_1.z.boolean().default(false),
    order: zod_1.z.number().int().default(0),
    slug: (0, slug_field_1.slugField)(191),
    slugEn: (0, slug_field_1.slugEnField)(191),
    productGroups: zod_1.z.string().default(""),
    productGroupsEn: zod_1.z.string().nullable().optional(),
    description: zod_1.z.string().default(""),
    descriptionEn: zod_1.z.string().nullable().optional(),
    documents: zod_1.z.array(exports.brandDocumentSchema).nullable().optional(),
});
// API verbatim create/update schemas (source of truth: apps/api/src/common/schemas.ts)
exports.brandCreateSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, "Marka adı zorunludur").max(191),
    nameEn: zod_1.z.string().max(191).nullable().optional(),
    initial: zod_1.z.string().min(1, "Başlangıç harfi zorunludur").max(191),
    categories: zod_1.z.string().min(1, "Kategoriler zorunludur"),
    categoriesEn: zod_1.z.string().nullable().optional(),
    logoUrl: zod_1.z.string().max(500).default(""),
    featured: zod_1.z.boolean().default(false),
    order: zod_1.z.number().int().default(0),
    slug: (0, slug_field_1.slugField)(191),
    slugEn: (0, slug_field_1.slugEnField)(191),
    productGroups: zod_1.z.string().default(""),
    productGroupsEn: zod_1.z.string().nullable().optional(),
    description: zod_1.z.string().default(""),
    descriptionEn: zod_1.z.string().nullable().optional(),
    documents: zod_1.z.array(exports.brandDocumentSchema).default([]),
});
exports.brandUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().cuid(),
    name: zod_1.z.string().min(1).max(191).optional(),
    nameEn: zod_1.z.string().max(191).nullable().optional(),
    initial: zod_1.z.string().min(1).max(191).optional(),
    categories: zod_1.z.string().min(1).optional(),
    categoriesEn: zod_1.z.string().nullable().optional(),
    logoUrl: zod_1.z.string().max(500).optional(),
    featured: zod_1.z.boolean().optional(),
    order: zod_1.z.number().int().optional(),
    slug: (0, slug_field_1.slugField)(191).optional(),
    slugEn: (0, slug_field_1.slugEnField)(191),
    productGroups: zod_1.z.string().optional(),
    productGroupsEn: zod_1.z.string().nullable().optional(),
    description: zod_1.z.string().optional(),
    descriptionEn: zod_1.z.string().nullable().optional(),
    documents: zod_1.z.array(exports.brandDocumentSchema).optional(),
});
//# sourceMappingURL=brand.js.map